"use client"

import { useQuery } from "@tanstack/react-query"

export interface ReferralClick {
  id: string
  code: string
  source: string | null
  ip_address: string | null
  user_agent: string | null
  fingerprint: string | null
  utm_params: Record<string, string> | null
  url_params: Record<string, string> | null
  created_at: string
}

export const REFERRAL_CLICKS_KEY = ["referral-clicks"] as const

export const useReferralClicks = (code?: string | null) => {
  return useQuery<ReferralClick[]>({
    queryKey: code ? ["referral-clicks", code] : REFERRAL_CLICKS_KEY,
    queryFn: async () => {
      const url = code
        ? `/api/referral/clicks?code=${encodeURIComponent(code)}`
        : "/api/referral/clicks"
      const res = await fetch(url)
      if (!res.ok) throw new Error("Failed to fetch clicks")
      return res.json()
    },
    refetchInterval: 30_000,
  })
}
